<template>  
  <div class="spodek" v-show="show">
    <div class="dvZaruka" v-show="zobrazZarukuRoky">
          <img v-bind="{ src: this.zarukaObrazek }" />
    </div>
    <div class="proButton flx">
      <div :class="clsCeny">
        <div :class="clsStitkuAkce">Kup levněji</div>
        <big>{{ cena_format }}</big>
        <strong v-show="zobrazCenuBezDPH"
          >{{ cenaBezDph_format }} bez DPH</strong
        >
        <div v-show="zobrazNelzeOdecistDPH" class="dvOptDph">
          Nelze odečíst DPH | <em>Osvobozeno podle §90</em>
        </div>
      </div>
      <div class="prava">
        <div class="vrch" v-show="zobrazVrch">
          <div v-show="zobrazBeznouCenu" class="dv1">
            <del>{{ beznaCena_format }}</del>
          </div>
          <div v-show="zobrazUsetris" class="dv2">
            Když nyní objednáš ušetříš <strong>{{ usetris_format }}</strong>
          </div>
        </div>
        <div class="kosik">

        </div>
      </div>
    </div>
    <div class="b">
    </div> 
    <div class="podButtonem flx">
      <div class="leva">
        
       
        <div v-show="zobrazZapoctenouSlevu" class="dv0 dvZapoctenaSleva">
          <p>
            Započítali jsme Vám slevu ve výši <strong>{{ sleva_format }}</strong
            ><br />
            <em>Nyní můžete s úsměvem objednat :)</em>
          </p>
        </div>
        <div v-show="zobrazRegistraciUsetrite" class="dvReg">
          <p>
            Cena pro členy <br><a
              class="show-tooltip aDoRegistrace"
              v-show="zobrazLinkDoregistrace"
              target="_blank"
              :data-original-title="tooltip"
              href="/registrace/"
              >Party Recomp</a
            >&nbsp;
            <strong>{{cenaPoRegistraci_format }}</strong>
            <a v-show="zobrazOdkazProIframe" v-on:click="vyuzitSlevu" href=""
              >Využít slevu</a
            >
          </p>
        </div>

        <div id="modarIframeReg" class="modal">
          <!--iframe width="100%" height="100%" src="/registrace/?iframe"></iframe-->
        </div>
      </div>
      <!--leva-->
      <div class="prava">
        <div class="cofidis" v-show="zobrazCofidis">
          <div class="flx">
            <div class="a"></div>
            <div class="b">
              <strong>Cofidis splátky </strong>
              <span v-if="zobrazMesicniSplatku"><em>od {{ cofidisSplatka_format }}</em> měsíčně</span>
            </div>
            <div class="c">
              <a @click.stop.prevent="otevriKalkulacku" :href="urlSplatek"  rel="noopener noreferrer">Spočítat splátky</a>
            </div>

          </div>
        </div>
        <div class="dvZtpI" v-show="zobrazZtp">
          <img
            class="show-tooltip"
            v-bind="{
              'data-original-title': this.ztpTitle,
              src: this.ztpObrazek
            }"
          />
        </div>
       
      </div>
    </div>
    <!--flx-->
  </div>
</template>

<script>
import * as detail from "../../page/detail.js";
import * as dopln from "../../incl/doplnkove-sluzby.js";
import { Top } from "../../class/Top.js";
export default {
  name: "spodek",
  data() {
    return {
      show: true,
      cena: 0,
      cenaBezDph: 0,
      cenaDoplnku:0,
      cenaDoplnkuBezDph:0,
      sleva: 0,
      reg_sleva: 0,
      reg_cena: 0,
      zobrazCenuBezDPH: true,
      zobrazZapoctenouSlevu: false,
      zobrazRegistraciUsetrite: true,
      zobrazNelzeOdecistDPH: false,
      zobrazOdkazProIframe: false,
      zobrazLinkDoregistrace: true,
      zobrazZarukuRoky: false,
      zobrazZtp: true,
      ztpObrazek: "",
      ztpTitle: "",
      zarukaObrazek: "",
      vybranaVariantaObj:false,

      usetris: 0,
      beznaCena: 0,

      zobrazUsetris: true,
      showVrch: true,
      zobrazBeznouCenu: true,

      povolenNakup:false, 

      //zobrazCofidis:true,
      mesicniSplatka:0,
      zobrazSplatku:false,


    };
  },
  computed: {
   
    zobrazVrch: function(){
      
      if(!this.showVrch){
        return false;
      }

      if(!this.povolenNakup){
        return false;
      }
      return true;

    },

    zobrazCofidis: function(){
      let c = $(".cofidis-wrap");
      if(!c.length){
        return false;
      }else if(!this.povolenNakup){
        return false;
      }

      return true;
    },


    zobrazMesicniSplatku:function(){
      if(!this.mesicniSplatka)return false;
      if(!this.zobrazSplatku)return false;
      return true;
    },
    urlSplatek: function(){
      return "#meladfas";
    },

    clsCeny: function(){
      if(this.beznaCena){
        return "leva bznC";
      }
      return "leva";
    },
    clsStitkuAkce: function(){
      if(!this.povolenNakup){
        return "kup";
      }else if(this.beznaCena){
        return "kup akce";
      }
      return "kup";
    },
    cofidisSplatka_format: function() {
      return Number(this.mesicniSplatka).formatCisla() + ",-";
    },
    beznaCena_format: function() {
      return Number(this.beznaCena).formatCisla() + " Kč";
    },
    usetris_format: function() {
      return Number(Math.round(this.usetris)).formatCisla() + " Kč";
    },
    tooltip: function() {
      let kod = `
      Zaregistujte se a získejte slevu
      `;
      return fce.escapeHtml(kod);
    },
    cena_format: function() {
      return Top.formatujMenu(this.cena+this.cenaDoplnku);
      //return Number(this.cena).formatCisla() + " sKč";
    },
    cenaBezDph_format: function() {
      return Top.formatujMenu(this.cenaBezDph+this.cenaDoplnkuBezDph);
      //return Number(this.cenaBezDph).formatCisla() + " Kč";
    },
    sleva_format: function() {
      return Top.formatujMenu(this.sleva);
      //return Number(Math.round(this.sleva)).formatCisla() + " Kč";
    },
    slevaPoRegistraci_format: function() {
      return Top.formatujMenu(this.reg_sleva);
      //return Number(Math.round(this.reg_sleva)).formatCisla() + " Kč";
    },
    cenaPoRegistraci_format: function() {
      return Top.formatujMenu(this.reg_cena);
      //return Number(Math.round(this.reg_sleva)).formatCisla() + " Kč";
    },
  },
  mounted() {
    this.nactiCeny();
    this.zobrazZtpIkonu();
    //this.zobrazZaruku();
    //this.nastavCofidis();

    let $this = this;
    $(document).on("ladzo:zmenenaVarianta", function(e, myData) {
      Lc.e("ladzo:zmenenaVariantaa", [e, myData]);
      let ObjCeny = dopln.vratCenyVybranychDolnku();
      
      $this.cenaDoplnku=ObjCeny.sum;
      $this.cenaDoplnkuBezDph=ObjCeny.sumNoVat;
      $this.nactiCenyProVariantu(myData);
      $this.vybranaVariantaObj=myData;

    });  
    $(document).on("ladzo:cenyDoplnkovychSluzeb", function(e, myData) {
      Lc.e("ladzo:cenyDoplnkovychSluzeb", [e, myData]);
      Lc.log('$this',$this);
      $this.showVrch = true;
      
      $this.cenaDoplnku=myData.sum;
      $this.cenaDoplnkuBezDph=myData.sumNoVat;
      Lc.log('upravit ceny',myData);
     
      if(detail.detailProduktu.maVarianty){
        $this.nactiCenyProVariantu($this.vybranaVariantaObj);
        
      }else{
        $this.nactiCeny();
      }
      $this.zobrazSplatku=true;
      //pro doplnkove sluzby ktere neco obsahuji skryji standardni cenu
      if(myData.sum){
        $this.showVrch = false;
        $this.zobrazSplatku=false;
      }
      



    }); 
    $(document).on("ladzo:cofidisMinPayement", function(e, el,minPayment) {
      Lc.e("lladzo:cofidisMinPayement", [e, el,minPayment]);
      if(minPayment){
        $this.zobrazSplatku=true;
        $this.mesicniSplatka=Number(minPayment);
      }
    
    }); 


  },
  methods: {

    otevriKalkulacku() {
      
      let cena = this.cena+this.cenaDoplnku;
      let urlLeas = `https://www.iplatba.cz/kalkulacka-nakupu-na-splatky/?cenaZbozi=${cena}&idObchodu=MzA0ODc=`;
     
      window.open(
        urlLeas,
        "targetWindow",
        "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600px,height=700px"
      );
      return false;
    },
    /*
    nastavCofidis: function(){
      let c = $(".cofidis-wrap");
      if(c.length){
        this.zobrazCofidis=true;
        Lc.log('nastavCofidis',c.text());
      }else{
        this.zobrazCofidis=false;
      }

    },
*/
    
    nastavPovolenNakup: function(){
      Lc.f('nastavPovolenNakup');  
      let c = $('#product-detail-form button.add-to-cart-button');
      Lc.log('c.length',c.length);

        if(!c.length){
          this.povolenNakup=false;
          return false;
        }  
        this.povolenNakup=true;
        return true;


    },
    
    zobrazZtpIkonu: function() {
      this.ztpObrazek = Top.shoptetUpload + "/detail/ztp.png?v3";
      //var $tooltip = "<p><strong>fdasf</strong>fdasfa</p>";
      var $tooltip = detail.det_slevProZtp();
      if ($tooltip == false) {
        this.zobrazZtp = false;
        return false;
      }

      //$tooltip = fce.escapeHtml($tooltip);
      this.ztpTitle = $tooltip;
    },

    zobrazZaruku: function() {
      Lc.f("zobrazZaruku ceny");
      var c = detail.paramDetail("Záruka");
      if (!c) return false;

      this.zobrazZarukuRoky = true;
      if (c == "2 roky") {
        this.zarukaObrazek = Top.shoptetUpload + "/detail/2roky.png?v3";
      } else if (c == "3 roky") {
        this.zarukaObrazek = Top.shoptetUpload + "/detail/3roky.png?v3";
      } else if (c == "1 rok") {
        this.zarukaObrazek = Top.shoptetUpload + "/detail/1rok.png?v3";
      }
    },

    spoctiSlevu:function(beznaCena,priceWithVat){
      Lc.f('---------spoctiSlevu---');
      let customer = Top.Uzivatel.Customer;
      let reg = fce.get(window.ruzne, "sleva.registrace") || false;
      if (
        customer &&
        customer.registered
      ) {
        this.zobrazRegistraciUsetrite = false;
        //this.zobrazZapoctenouSlevu = true;

        //this.sleva = beznaCena - priceWithVat;
      } else {
        this.reg_sleva = reg.procento * (priceWithVat + this.cenaDoplnku );
        this.reg_cena =(1 - reg.procento)*priceWithVat + this.cenaDoplnku;
      }
    },
    nactiCenyProVariantu(data){
      Lc.f("nacti ceny nactiCenyProVariantu",data);
      
      this.nastavPovolenNakup();
      
      let P = data.sklad[data.id] || false;
      Lc.log('Produkt',P);

      
      Lc.log('this',this);

      this.cenaBezDph=P.additionalPrice.prevedNaCislo();
      this.cena=P.price.prevedNaCislo();


      this.zobrazBeznouCenu=true;
      this.showVrch=true;
      let beznaCena = P.standardPrice.prevedNaCislo();
      if(beznaCena){
        this.beznaCena = beznaCena;
        this.usetris = this.beznaCena - this.cena;
        
      }else{
        this.zobrazBeznouCenu=false;
        this.showVrch=false;
      }
      this.spoctiSlevu(1000,this.cena);






    },
    nactiCeny: function() {
      Lc.f("nacti ceny",detail.detailProduktu);
      
      this.nastavPovolenNakup();

      if (
        detail.paramDetail("opt_dph") !== false &&
        detail.paramDetail("opt_dph") == "0"
      ) {
        this.zobrazNelzeOdecistDPH = true;
        this.zobrazCenuBezDPH = false;
      }
      
      if(detail.detailProduktu.maVarianty){
        return false;
      }
      
      //pokracuje poouze pro produkt bez variant
      
      var Pr = fce.get(window.dataLayer[0], "shoptet.product") || false;
      Lc.log('Pr',Pr);
      
      this.cena = detail.detailProduktu.Product.priceWithVat;
      this.cenaBezDph = detail.detailProduktu.cenaBezDPH;

      let a = detail.detailProduktu.BeznaCena;

      //if (process.env.NODE_ENV == "development" && !a) a = 5490;
      this.showVrch = true;
      if (!a) {
        this.showVrch = false;
      }
      this.beznaCena = a;
      this.usetris = a - detail.detailProduktu.Product.priceWithVat;

      Lc.log('sfsdfds',[this.beznaCena,this]);

      this.spoctiSlevu(detail.detailProduktu.BeznaCena,detail.detailProduktu.Product.priceWithVat);
      /*
      
      let customer = Top.Uzivatel.Customer;
      let reg = fce.get(window.ruzne, "sleva.registrace") || false;
      if (
        customer &&
        reg &&
        customer.registered &&
        reg.groupId == customer.groupId
      ) {
        this.zobrazRegistraciUsetrite = false;
        this.zobrazZapoctenouSlevu = true;

        this.sleva =
          detail.detailProduktu.BeznaCena -
          detail.detailProduktu.Product.priceWithVat;
      } else {
        this.reg_sleva =
          reg.procento * detail.detailProduktu.Product.priceWithVat;
      }
      Lc.log('Ukazat',[this.cena]);

      */
      if (!this.cenaBezDph) {
        this.zobrazCenuBezDPH = false;
        return false;
      }
    },
    vyuzitSlevu: function(e) {
      Lc.h("click");
      $("#nouzovy_stav").hide();
      e.preventDefault();
      $("#modarIframeReg").modal();
      $("#modarIframeReg").on($.modal.BEFORE_OPEN, function() {
        //Lc.h("-open-");
      });
      $("#modarIframeReg").on($.modal.AFTER_CLOSE, function() {
        //Lc.h("-close-");
        location.reload();
      });
    }
  }
};
</script>

<style lang="less">

@import "../../less/variable.less";
@import "../../less/mixin.less";

#dvCenyBox .vrch {
 
  .flex;

  @media (max-width:480px){
    flex-direction: column;
    align-items: center;
  }
  .dv1,.dv2{
    display: inline-block;
  }
  .dv1 {
    color: @color-red;
    del {
      color: @color-black;
      display: inline-block;
      margin-left: 1em;
      margin-right: 1em;
      font-weight: 600;
      font-size: 16px;
    }
  }
  .dv2 {
    flex: 1;
    @media (max-width: 680px) {
      /*
      flex: 0 1 100%;
      margin: 10px 0;
      text-align: left;
      */
    }
    strong {
      color: @color-red;
      font-weight: 600;
      white-space: nowrap;
    }
  }
}


#dvCenyBox {
  .spodek {
    padding: 10px 10px 1em 10px;
    .dvZaruka {
        text-align: right;
        margin-bottom: 30px;
        img {
          width: 100px;
        }
    }
    .proButton{
      align-items: flex-end;
      @media (max-width: 680px) {
        align-items: center;
      }
    }

    .flx {
      .flex;
      @media (max-width: 680px) {
        flex-direction: column;
      }
      > .leva {
        flex: 1;
      }
      > .prava {
        flex: 0 1 360px;
        @media (max-width: 680px) {
          flex: 0 1 100%;
          margin: 20px 0 0 0;
          display: block;
        }
      }
    }
    big {
      //margin-top: 10px;
      font-size: 30px;
      color: #333;
      font-weight: bold;
    }
    div.leva.bznC{
      big{
        color:@color-red;
      }
    }

    p {
      margin: 0;
    }
    div.leva {
      > em,
      > big,
      > strong {
        display: block;
      }
    }

    div.prava {
      .dvZtpI {
        text-align: right;
        img {
          width: 120px;
        }
      }
     
      .dvZtpI {
        margin-bottom: 20px;
      }
    }
    
    .dvReg {
     @media (max-width:680px){
      text-align: center;
     }
      p > a {
        display: inline-block;
        .odkP;
      }
    }
    .dvOptDph {
      em {
        font-style: normal;
        color: #c8b080;
      }
    }


    div.kup {
      visibility: hidden;
    }

    div.kup.akce {
      visibility: visible;
      text-transform: uppercase;
      display: inline-block;
      font-size: 13px;
      background: @color-red;
      color: #fff;
      padding: 0 12px;
      line-height: 25px;
      font-weight: bold;
      margin-bottom: 15px;
      position: relative;

      &:after {
          content: "";
          width: 0px;
          height: 0px;
          border-style: solid;
          border-width: 9px 9px 0 9px;
          border-color: #af0000 transparent transparent transparent;
          display: block;
          position: absolute;
          left: 0;
          bottom: -9px;

      }
    }

  }
  .kosik{
    .add-to-cart-button{
      flex:1;
      span{
        @media (max-width:460px){
          display: none;
        }
      }

    }
    @media (max-width:680px){
      margin-top: 20px;
    }
  }
  .podButtonem{
    margin-top: 20px;
    align-items: center;
  }
  .cofidis{
    background:#fdf9eb;
    border-radius: 45px 0 0 45px;
    padding: 20px;
    @media (max-width:680px){
      width: 360px;
    }
    @media (max-width:480px){
      width: auto;
      margin-top: 20px;
      border-radius: 45px;
      padding: 20px 45px;
    }
    .flx{
      .flex;
      align-items: center;
      justify-content: space-between;

      @media (max-width:480px){
        flex-direction: column;
        >div{
          margin: 10px 0;
        }
        
      }
    }
    .b{
      line-height: 1.4;
      strong{
        display: block;
        color:@color-red;
      }
      em{
        font-style: normal;
        font-weight: bold;
      }
    }
    .c{
      a{
        text-decoration: none;
        display: inline-block;
        background: @color-red;
        color: #fff;
        padding: 10px 10px;
        justify-content: space-between;
        &:hover{
          background: darken(@color-red, 20%);
        }
      }
    }
    
  }
}
</style>
